module.exports = __webpack_public_path__ + "static/media/jedediahs-header-logo.3f7c4f32.png";